
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-1fde7b42&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./commoditymanagement.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./commoditymanagement.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-1fde7b42!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./commoditymanagement.vue"),
  /* scopeId */
  "data-v-1fde7b42",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/storeManagement/commoditymanagement.vue
// module id = 1591
// module chunks = 3